import { CheckoutOrderValidationError, CheckoutOrderValidationRule } from '../enum/checkout-order-validation.enum';

export const checkoutOrderTypeRule: CheckoutOrderValidationRule = ({ hasOrderType }) =>
	hasOrderType ? null : CheckoutOrderValidationError.OrderTypeUnavailable;
